import React, { isValidElement } from 'react';
import cn from 'classnames';
import Subtitle from '../Subtitle/Subtitle';
import styles from './Cell.module.scss';

const Cell = ({ title, content, className, htmlFor }) => {
  return (
    <div className={cn(styles.root, className)}>
      <Subtitle text={title} htmlFor={htmlFor} />
      {isValidElement(content) ? (
        content
      ) : (
        <p className={styles.content}>{content}</p>
      )}
    </div>
  );
};

export default Cell;
